/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingQueryCloudAccount extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSecurityHubFindingQueryCloudAccount");
    }

    getFixupPrototypeFunction() { return AwsSecurityHubFindingQueryCloudAccount.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingQueryCloudAccount>): AwsSecurityHubFindingQueryCloudAccount {
        let obj = Object.assign(new AwsSecurityHubFindingQueryCloudAccount(), model);
        AwsSecurityHubFindingQueryCloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingQueryCloudAccount>): AwsSecurityHubFindingQueryCloudAccount {
        if (!model) return null;
        return AwsSecurityHubFindingQueryCloudAccount.newInstance(<AwsSecurityHubFindingQueryCloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingQueryCloudAccount) {
        if (!obj) return;

        models.AwsSecurityHubFindingQueryCloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingQueryCloudAccount): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSecurityHubFindingQueryCloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud Accounts for the resources
     */
    cloud_account_ids: Array<string>;

}
